import React, { useEffect } from 'react';
// import logo from './logo.svg';
import { Route, Redirect, Link, BrowserRouter as Router } from 'react-router-dom';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { connect } from "react-redux";
import './AdmApp.css';
import DlUnitLi from './DlUnitLi';
import DlUnitEdit from './DlUnitEdit';
import DlUnitPdfUpd from './DlUnitPdfUpd';
import DlUnitScanUpd from './DlUnitScanUpd';
import DlGroupEdit from './DlGroupEdit';
import { admMenuWrap } from "../componentCommon";
import DlGroupLi from './DlGroupLi';
import AdmPhotoSerLi from './AdmPhotoSerLi';
import AdmPhotoSerEdit from './AdmPhotoSerEdit';
import AdmPhotoSerPhUpd from './AdmPhotoSerPhUpd';
import UserLi from './UserLi';
import UserEdit from './UserEdit';
import TestAdm01 from './TestAdm01';
import { authCh } from "../../actions";

const mapStateToProps = (state) => ({
  uType: state.auth.uType
});

const mapDispatchToProps = (dispatch) => ({
  authCh: (payload) => dispatch(authCh(payload)),
});

let App = ({ uType, authCh }) => {
  useEffect(function() {
    console.log('Adm App authCh');
    if (uType == '') {
      authCh();
      
    }
    // authCh();    
    
  }, [uType]);

  if (uType != 'admin') {
    // return <Redirect to='/l-in' />;        
    return <Container>
      <Row style={{ 'marginTop': '2em', textAlign: 'center' }}>
          <Col xs={12} md={{ span: 6, offset: 3 }} lg={{ span: 4, offset: 4 }}>
              <Link to="/l-in" style={{ marginTop: '1em' }}>
                  Uloguj se
              </Link>        
          </Col>
      </Row>
    </Container>;        
  } else {
    return (<div className="App">
      <Router>
        <div style={{ width: '90%' }}>
          <Route path="/admin-dashboard/" exact component={DlUnitLi} />
          <Route path="/admin-dashboard/dl-unit-li" component={DlUnitLi} />
          <Route path="/admin-dashboard/dl-unit-edit" exact component={DlUnitEdit} />
          <Route path="/admin-dashboard/dl-unit-edit/:itemId" component={DlUnitEdit} />
          <Route path="/admin-dashboard/dl-unit-edit-pdf/:itemId" component={DlUnitPdfUpd} />
          <Route path="/admin-dashboard/dl-unit-edit-scan/:itemId" component={DlUnitScanUpd} />
      
          <Route path="/admin-dashboard/dl-group-li" component={DlGroupLi} />
          <Route path="/admin-dashboard/dl-group-edit" exact component={DlGroupEdit} />
          <Route path="/admin-dashboard/dl-group-edit/:slug" component={DlGroupEdit} />
      
          <Route path="/admin-dashboard/photo-ser-li" component={AdmPhotoSerLi} />
          <Route path="/admin-dashboard/photo-ser-edit" exact component={AdmPhotoSerEdit} />
          <Route path="/admin-dashboard/photo-ser-edit/:itemId" component={AdmPhotoSerEdit} />
          <Route path="/admin-dashboard/photo-ser-edit-ph/:itemId" component={AdmPhotoSerPhUpd} />
      
          <Route path="/admin-dashboard/user-li" component={UserLi} />
          <Route path="/admin-dashboard/user-edit" exact component={UserEdit} />
          <Route path="/admin-dashboard/user-edit/:itemId" component={UserEdit} />
      
          <Route path="/admin-dashboard/test-adm-01" component={TestAdm01} />
        </div>
      </Router>
    </div>);
  }

} 

App = admMenuWrap(App);
export default connect(mapStateToProps, mapDispatchToProps)(App);
